import { NetworkItem } from "@/redux/slices/network/types";
import { ReceivedInvitationBanner } from "./ReceivedInvitationBanner";

interface ReceivedInvitationsBannerListProps {
  items: NetworkItem[];
}

export const ReceivedInvitationsBannerList = ({ items }: ReceivedInvitationsBannerListProps) => {
  if (items.length === 0) return null;

  return (
    <div className="mb-4 flex flex-col gap-2">
      {items.map((item) => (
        <ReceivedInvitationBanner key={item.id} item={item} />
      ))}
    </div>
  );
};
